import type {
  PayrollStatementNotificationDelivery,
  PayrollStatementNotificationDeliveryStatus,
  PayrollStatementSmsDelivery,
} from "./types";

export const PAYROLL_STATEMENT_DELIVERY_STATUS = {
  pending: "pending",
  enqueued: "enqueued",
  failed: "failed",
  succeeded: "succeeded",
  skipped: "skipped",
} as const satisfies Record<
  PayrollStatementNotificationDeliveryStatus,
  PayrollStatementNotificationDeliveryStatus
>;

export const isPayrollStatementDeliveryInProgress = (
  status: PayrollStatementNotificationDeliveryStatus,
) =>
  status === PAYROLL_STATEMENT_DELIVERY_STATUS.pending ||
  status === PAYROLL_STATEMENT_DELIVERY_STATUS.enqueued;

export const isPayrollStatementDeliveryFailed = (
  status: PayrollStatementNotificationDeliveryStatus | null,
) => status === PAYROLL_STATEMENT_DELIVERY_STATUS.failed;

export const isPayrollStatementDeliverySuccessful = (
  status: PayrollStatementNotificationDeliveryStatus | null,
) => status === PAYROLL_STATEMENT_DELIVERY_STATUS.succeeded;

/**
 * Handed to the carrier, which is as far as some carriers ever report: no delivery
 * receipt will follow, so nothing should keep waiting on one.
 */
export const isSmsDeliveryWithCarrier = (sms: PayrollStatementSmsDelivery) =>
  sms.status === PAYROLL_STATEMENT_DELIVERY_STATUS.enqueued &&
  sms.provider_status === "sent";

/** A text still worth polling for: queued at Twilio, not yet with the carrier. */
export const isSmsDeliveryInFlight = (
  sms: PayrollStatementSmsDelivery | null | undefined,
) =>
  !!sms &&
  (sms.status === PAYROLL_STATEMENT_DELIVERY_STATUS.pending ||
    sms.status === PAYROLL_STATEMENT_DELIVERY_STATUS.enqueued) &&
  !isSmsDeliveryWithCarrier(sms);

/** The API's skip reason on the email of a send the manager chose to text only. */
export const EMAIL_NOT_SELECTED = "email_not_selected";

/**
 * A send that went out by text only. The email row is skipped on purpose, and the
 * PayPack was published all the same, so this counts as sent, not skipped.
 */
export const isTextOnlyDelivery = (
  delivery: PayrollStatementNotificationDelivery | null | undefined,
) =>
  delivery?.status === PAYROLL_STATEMENT_DELIVERY_STATUS.skipped &&
  delivery.skip_reason === EMAIL_NOT_SELECTED;
